module.exports = __webpack_public_path__ + "static/img/CEO.6692fec1.jpg";